import {createContext} from '@lit/context';
import {WishlistRouter} from '../../templates/components/wishlist-app/wishlist-router.js';

export interface WishlistAppConfig {
  appUrl: string
  favoritesEndpoint: string
  collectionEndpoint: string
  curatedCollectionEndpoint: string
  favoritesEndpoints: string[]
  curatedCollectionEndpoints: string[]
  collectionEndpoints: string[]
  loginEndpointWithFavoritesReferrer: string
  loginEndpointWithFavoritesEventLayerOpenReferrer: string
  loginEndpointWithCollectionReferrer: string
  loginEndpointWithCuratedCollectionReferrer: string
  curatedCollectionApiEndpoint: string
  curatedCollectionApiToModifyBocaEndpoint: string
  productEndpoint: string,
  mixAndMatchEndpoint: string
  productLineEndpoint: string
  capsuleEndpoint: string
  eventsEndpoint: string
  eventsSeenEndpoint: string
  eventsAppLayerEndpoint: string,
  cartEndpoint: string
  isAppNativeBottomSheetEnabled: boolean,
  surveyCollectorId: string,
  surveyEnabled: boolean,
  showChristmasBear: boolean,
  isCurator: boolean,
  hasCuratedCollections: boolean,
  // === abtest-ents-t6727-favoriten-artikelkachel-redesign Product Tile Redesign START ===
  productTileRedesign: boolean
  // === abtest-ents-t6727-favoriten-artikelkachel-redesign Product Tile Redesign END ===
}

export const wishlistAppConfigContext = createContext<WishlistAppConfig>('wishlistAppConfigContext');
export const wishlistRouterContext = createContext<WishlistRouter>('wishlistRouterContext');
